import styled, { css } from 'styled-components';

export const Container = styled.div(
  () => css`
    position: relative;
    width: 100%;
    height: 100%;
  `,
);

export const ReferenceCharacter = styled.div<{ $opacity: number }>(
  ({ $opacity }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 200px;
    line-height: 1;
    color: rgba(0, 0, 0, 0.15);
    opacity: ${$opacity};
    transition: opacity 0.5s ease-out;
    pointer-events: none;
    user-select: none;
  `,
);

export const Canvas = styled.canvas(
  () => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: crosshair;
    touch-action: none;
  `,
);
